export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Створити допис...',
  blogsFeedSearchInputPlaceholder: 'Пошук',
  blogsFeedPostOwnerCurtainEditTitle: 'Редагувати допис',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Видалити допис',
  blogsFeedEditedPostSavedAlertText: 'Допис збережено!',
  blogsFeedEditedPostDeletedAlertText: 'Допис видалено!',
  blogsFeedShareCurtainOptionTitle: 'Скопіювати посилання',
  blogsFeedPostLinkCopiedAlertText: 'Посилання скопійовано!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Скопіювати посилання',
  blogsFeedOthersPosLinkCopiedAlertText: 'Посилання скопійовано!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Поскаржитись',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Видалити допис',
  blogsFeedPostDeletePopupTitle: 'Видалити',
  blogsFeedPostDeletePopupText: 'Видалити цей допис?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Скасувати',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Підтвердити',
  blogsFeedPostDeeletedAlertText: 'Допис видалено!',
  blogsPostDetailsHeaderTitle: 'Допис',
  postFeedPostLikesText: 'Вподобання',
  postFeedPostCommentsText: 'Коментарі',
  postFeedPostNoLikesText: 'Поки що жодного вподобання.',
  postFeedPostLeaveFirstLikeText: 'Залиш перше вподобання',
  blogsFeedPostDetailsNoCommentsText: 'Поки що жодних коментарів',
  blogsFeedPostDetailsFirstCommentText: 'Залиш перший коментар',
  blogsFeedPostDetailsShareOptionTitle: 'Скопіювати посилання',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Посилання скопійовано!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Скопіювати посилання',
  blogsFeedPostDetailsCopiedAlertText: 'Посилання скопійовано!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Поскаржитись',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Поскаржитись',
  blogsPostDetailsReportedCurtainText: 'Скаргу надіслано',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Редагувати коментар',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Видалити коментар',
  blogsPostDetailsEditedCommentSavedAlertText: 'Коментар збережено!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Видалити коментар',
  postDetailsOtherUsersCommentDeletadAlertText: 'Коментар видалено!',
  postDetailsDeleteCommentPopupTitle: 'Видалити',
  postDetailsDeleteCommentPopupText: 'Видалити цей коментар?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Скасувати',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Підтвердити',
  postDetailsCommDeletedAlertText: 'Коментар видалено!',
  postDetailsCommentUserCurtainOptionTitle: 'Поскаржитись на коментар',
  blogsCreatePostCurtainTitle: 'Новий допис',
  blogsCreatePostCurtainBodyPlaceholder: 'Почніть писати тут...',
  blogsCreatePostPublishButtonTitle: 'Опублікувати',
  blogsCreatePostUploadSlallerImageAlertText: 'Ви не можете завантажувати більше {size} MB за раз',
  blogsPostSavedAlertText: 'Допис збережено!',
  blogsCreatePostAddLocationCurtainTitle: 'Локація',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Назва локації',
  blogsCreatePostEditLocationCurtainText: 'Редагувати локацію',
  blogsDeleteLocation: 'Видалити локацію',
  blogsDiscardPostPopupTitle: 'Чернетка',
  blogsDiscardPostPopupText: 'Видалити чернетку?',
  blogsDiscardPostPopupCancelButtonTitle: 'Скасувати',
  blogsDiscardPostPopupCofirmButtonTitle: 'Підтвердити',
  blogsNewPostCreatePollTitle: 'Створити опитування',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Назва',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Варіант',
  blogsNewPostCreatePollAddButtonTitle: 'Додати варіант',
  blogsNewPostCreatePollCreateButtonTitle: 'Створити',
  blogsCreatePostPollTitleBlankAlertText: 'Заповніть поле!',
  blogsCreatePostPollOptionBlankAlertText: 'Заповніть поле!',
  blogsCreatePostPollLongTitleAlertText: 'Задовга назва, оберіть не довше {length} символів',
  blogsCreatePostPollLongOptionAlertText: 'Задовгий варіант, оберіть не довше {length} символів',
  blogsCreatePostPollEditOptionTitle: 'Редагувати опитування',
  blogsCreatePostPollRemoveOptionTitle: 'Видалити опитування',
  blogsPostPollInfoVotesText: 'голосів',
  blogsPostPollInfoEditVoteText: 'Переголосувати',
  blogsPostPollFinishPollText: 'Завершити',
  blogsPostPollFinishedPollText: 'Завершено',
  blogsPostPollInProgresslText: 'В процесі',
  blogsFinishPollCurtainTitle: 'Завершити',
  blogsFinishPollCurtainText: 'Користувачі більше не зможуть голосувати в цьому опитуванні, коли воно буде закінчено.',
  blogsFinishPollCurtainCancelButtonTitle: 'Скасувати',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Підтвердити',
  blogsPollInfoPollVotesCurtainTitle: 'Голоси',
  blogsEditPostCurtainTitle: 'Редагувати допис',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Почніть писати тут...',
  blogsEditPostCurtainSaveButtonTitle: 'Зберегти',
  blogsEditPostSavedAlertText: 'Допис збережено!',
  blogsError: 'Щось пішло не так!',
  blogsAt: 'у',
  blogsSeeMore: 'Розгорнути...',
  blogsMaxAttachments: 'Ви перевищили максимальну кількість фотографій. Максимальна кількість становить {max} фото',
  blogsReply: 'Відповісти',
  blogsAddCover: 'Додати обкладинку'
}
